import type { RouteOption } from "../../../api/threads/routeOptions";
import type { OverridePrefill } from "../../processAuthoring/capabilities/overrideDrafts";

/**
 * The capabilities a route's turns need that nobody has stated (unknown, not lacking), each
 * as the override entry a team could assert for it (capabilities.md CAP-4): matched by the
 * route's own identity and the model, with the value the requirement asks for.
 */
export function assertableGaps(option: RouteOption): OverridePrefill[] {
  if (option.routeIdentity === null) {
    return [];
  }
  const prefills = new Map<string, OverridePrefill>();
  for (const fit of option.fits) {
    for (const requirement of fit.requirements) {
      if (requirement.outcome !== "unknown" || prefills.has(requirement.capability)) {
        continue;
      }
      prefills.set(requirement.capability, {
        routeKind: option.route.kind,
        routeMatch: option.routeIdentity,
        modelMatch: option.route.model_id ?? "*",
        key: requirement.capability,
        value: requirement.equals ?? requirement.atLeast ?? true,
      });
    }
  }
  return [...prefills.values()];
}
